var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63.4800012px",
    height: "52.3px",
    viewBox: "0 0 63.4800012 52.3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-1279.139999, -3780.390000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "translate(-0.060000, -1.890000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1301.57002,3819.61 C1301.57745,3816.61624 1299.77604,3813.91444 1297.00959,3812.77015 C1294.24314,3811.62587 1291.05952,3812.26572 1288.95,3814.39 L1288.94,3814.38 C1287.54934,3815.76378 1286.76833,3817.64525 1286.7702,3819.60708 C1286.77208,3821.56891 1287.5567,3823.44889 1288.95,3824.83 L1288.94,3824.84 C1290.32527,3826.23023 1292.20742,3827.01116 1294.17,3827.01 L1294.17,3827.02 C1298.25487,3827.00571 1301.56122,3823.69489 1301.57002,3819.61 L1301.57002,3819.61 Z M1309.13,3819.61 C1309.12866,3823.57363 1307.54896,3827.37355 1304.74,3830.17 L1304.73,3830.18 C1301.93241,3832.98604 1298.13236,3834.56219 1294.17,3834.56 L1294.17,3834.58 C1290.20513,3834.57502 1286.40537,3832.99178 1283.61,3830.18 L1283.6,3830.18 C1280.7839,3827.38549 1279.2,3823.58233 1279.2,3819.615 C1279.2,3815.64767 1280.7839,3811.84451 1283.6,3809.05 L1283.6,3809.04 C1287.88175,3804.77867 1294.30514,3803.50841 1299.88657,3805.81925 C1305.468,3808.13009 1309.11359,3813.56913 1309.13,3819.61 L1309.13,3819.61 Z",
    id: "Path_41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_42",
    points: "1342.68 3782.28 1342.68 3801.03 1312.75 3801.03 1312.75 3782.28 1320.32 3782.28 1320.32 3793.46 1335.12 3793.46 1335.12 3782.28"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon6.b45806812624ea906edb3726ea7069b7.svg";
export { ForwardRef as ReactComponent };